<template>
  <q-page>
    <Sumula :id="id" />
  </q-page>
</template>

<script setup>
import Sumula from "../components/enunciado/Enunciado.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
const route = useRoute();
const id = computed(() => route.params?.id);
</script>
